import FormItem from '../form/form-item.vue';

export default FormItem;


// WEBPACK FOOTER //
// ./node_modules/iview/src/components/form-item/index.js